export default "__VITE_ASSET__DswNPdHy__";